document.addEventListener('DOMContentLoaded', function () {

    if (typeof SalesforceInteractions === 'undefined') return;
    if (typeof meta === 'undefined') return;
    if (!meta.product) return;

    const sku = meta.product.variants?.[0]?.sku || '';
    const productName = meta.product.variants?.[0]?.name || '';
    const brand = meta.product.vendor || '';

    const categories = window.salesforceProductData?.categories || [];

    SalesforceInteractions.sendEvent({
        interaction: {
            name: 'View-Catalog-Object',
            catalogObject: {
                type: 'Product',
                id: sku,
                productName: productName,
                productCategory: categories.join(', '),
                brand: brand,
                sku: sku
            }
        }
    })
    .then(() => {

    })
    .catch(error => {
        console.error('Salesforce Product View error', error);
    });

});